import axios from "axios";

import { getRefreshToken } from "../service";
import { UseAuthStore } from "../store";

let isRefreshing = false;
let refreshSubscribers: ((token: string) => void)[] = [];

function onRefreshed(token: string) {
  refreshSubscribers.forEach((callback) => callback(token));
  refreshSubscribers = [];
}

function addSubscriber(callback: (token: string) => void) {
  refreshSubscribers.push(callback);
}

export function setupAxios(useAuthStore: UseAuthStore, apiBaseUrl?: string) {
  if (!apiBaseUrl) {
    throw new Error("API_BASE_URL is not defined");
  }

  axios.defaults.baseURL = apiBaseUrl;

  // Request interceptor
  axios.interceptors.request.use(
    (config) => {
      const { accessToken } = useAuthStore.getState();

      if (accessToken && config.headers) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }

      return config;
    },
    (error) => Promise.reject(error),
  );

  // Response interceptor
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const originalRequest = error.config;

      if (error.response?.status === 401 && !originalRequest._retry) {
        if (isRefreshing) {
          return new Promise((resolve) => {
            addSubscriber((token) => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              resolve(axios(originalRequest));
            });
          });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        const { refreshToken, login, logout } = useAuthStore.getState();

        if (refreshToken) {
          return getRefreshToken(refreshToken)
            .then(({ data, success }) => {
              isRefreshing = false;

              if (!success) {
                logout();
                return Promise.reject(error);
              }

              if (data && data.token && data.refreshToken) {
                login(data.token, data.refreshToken);
                onRefreshed(data.token); // Bekleyen istekleri tamamla
                originalRequest.headers.Authorization = `Bearer ${data.token}`;
                return axios(originalRequest);
              }

              return Promise.reject(error);
            })
            .catch((refreshError) => {
              isRefreshing = false;
              logout();
              return Promise.reject(refreshError);
            });
        }
      }

      return Promise.reject(error);
    },
  );
}
